import React, { useEffect, useState, useCallback } from "react";
import { Loading } from "components/ui";
import ErrorView from "components/ui/ErrorView/ErrorView";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
import { getErrorMessage } from "utils/helper";
import {
    appMessageUserTypes,
    messageTypes,
} from "../../ChatModule/LiveChat/MessageBody/Messages/Message/enums";
import TMTagDetailElement from "./TMTSuggestionElement/TMTagDetail/TMTagDetailElement/TMTagDetailElement";
import TMTSuggestionElement from "./TMTSuggestionElement/TMTSuggestionElement";
import { RECEIVE_MESSAGE, SUBSCRIBE_TO_TICKET } from "services/socket/events";
import { useSocket } from "services/socket/hook";

const { IDLE, LOADING, ERROR, NULLMODE, DATAMODE } = dataQueryStatus;
const { THIRD_USER } = appMessageUserTypes;
const { DEFAULT } = messageTypes;

const TMessageTagSuggestion = ({
    selectedTicket,
    recentCustomerMessage,
    setCannedMessage,
}) => {
    const { ticketId } = selectedTicket;
    const socket = useSocket() // Access the socket from context
    const [status, setStatus] = useState(LOADING);
    const [errorMssg, setErrorMssg] = useState("");
    const [availableMTs, setAvailableMts] = useState();
    const { messageContent } = recentCustomerMessage || {};

    const getMessagingTags = async () => {
        try {
            setStatus(LOADING);
            const res = await API.get(apiRoute.getMessageTags);

            if (res.status === 200) {
                const { data } = res.data;
                if (data.length > 0) {
                    setAvailableMts(data);
                    setStatus(DATAMODE);
                } else {
                    setStatus(NULLMODE);
                }
            }
        } catch (err) {
            setErrorMssg(getErrorMessage(err));
            setStatus(ERROR);
        }
    };

    const investigateMessageTags = async (messageContent) => {
        try {
            // Check if messageContent exists and is not empty after trimming
            const trimmedContent = messageContent?.trim();
            if (trimmedContent && trimmedContent.length > 0) {
                setStatus(LOADING);
                setErrorMssg();

                const url = apiRoute?.investigateMessage;
                const res = await API.get(url, {
                    params: {
                        search: trimmedContent,
                    },
                });
                if (res.status === 200) {
                    const { data } = res.data;
                    if (data.length > 0) {
                        setAvailableMts(data);
                        setStatus(DATAMODE);
                    } else {
                        setStatus(NULLMODE);
                    }
                }
            } else {
                // If message is empty, just get regular messaging tags
                getMessagingTags();
            }
        } catch (err) {
            setStatus(ERROR);
            setErrorMssg(getErrorMessage(err));
        }
    };

    const renderBasedOnStatus = () => {
        switch (status) {
            case IDLE:
                return "";

            case LOADING:
                return <Loading />;

            case NULLMODE:
                return (
                    <>
                        <TMTagDetailElement
                            lastMessageContent={messageContent}
                            selectedTicket={selectedTicket}
                        />
                    </>
                );

            case DATAMODE:
                return (
                    <TMTSuggestionElement
                        selectedTicket={selectedTicket}
                        availableMTs={availableMTs}
                        lastMessageContent={messageContent}
                        setCannedMessage={setCannedMessage}
                    />
                );

            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getMessagingTags}
                    />
                );

            default:
                return "";
        }
    };

    const acceptNewMessageForInvestigation = useCallback((message) => {
        const { messageType, senderType, messageContent } = message;
        // Only investigate if message type is DEFAULT, sender is THIRD_USER, and message is not empty
        const trimmedContent = messageContent?.trim();
        if (messageType === DEFAULT && senderType === THIRD_USER && trimmedContent && trimmedContent.length > 0) {
            investigateMessageTags(messageContent);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        let httpRequest = new AbortController();

        // Only call investigateMessageTags if messageContent exists and is not empty
        const trimmedContent = messageContent?.trim();
        if (trimmedContent && trimmedContent.length > 0) {
            investigateMessageTags(messageContent);
        } else {
            // If message is empty, get regular messaging tags
            getMessagingTags();
        }
        
        socket?.emit(SUBSCRIBE_TO_TICKET, { ticketId });
        socket?.on(RECEIVE_MESSAGE, acceptNewMessageForInvestigation);

        return () => {
            httpRequest.abort();
            socket.off(RECEIVE_MESSAGE);
        };
        //eslint-disable-next-line
    }, []);

    return <div>{renderBasedOnStatus()}</div>;
};

export default TMessageTagSuggestion;
